/**
 * Repositorio para el consumo de datos desde la API Rest
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiGetWishlistResponse, ApiPutWishlistRequest, ApiPutWishlistResponse } from '../../domain/models/api-wishlist.models';

import { HttpRequestsService } from '@core/infrastructure/http-requests/http-requests.service';

@Injectable()
export class WishlistApiRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService
    ) {}

    /**
     * Get wishlist
     *
     * @param storeId Store id
     * @param languageId Language id
     * @param catalogId Catalog id
     * @param index
     * @param whislistUrl Whislist url (Optional)
     *
     * @returns wishlist
     */
    public getWishlist(
        storeId: string,
        languageId: string,
        catalogId?: string,
        index?: string,
        whislistUrl?: string
    ): Observable<ApiGetWishlistResponse> {
        const slug = whislistUrl ? `wish/store/${storeId}/wishlist` : `store/${storeId}/wishlist`;
        const params = [{ key: 'catalogId', value: catalogId }];
        const restApi = whislistUrl ? whislistUrl.split('/')[1] : 'itxrestservcart';
        const apiVersion = whislistUrl ? '4' : '2';
        const url = this.requestService.requestUrl(
            slug,
            languageId,
            params,
            true,
            apiVersion,
            restApi
        );

        if (index) {
            params.push({ key: 'index', value: index });
        }
        return this.http.get<ApiGetWishlistResponse>(url, { withCredentials: true });
    }

    /**
     * Add or delete items on wishlist
     *
     * @param storeId Store id
     * @param languageId Language id
     * @param catalogId Catalog id
     * @param body Body
     * @param whislistUrl Whislist url (Optional)
     *
     * @returns wishlist
     */
    public putWishlist(
        storeId: string,
        languageId: string,
        catalogId: string,
        body: ApiPutWishlistRequest,
        whislistUrl?: string
    ): Observable<ApiPutWishlistResponse> {
        const slug = whislistUrl ? `wish/store/${storeId}/wishlist` : `store/${storeId}/wishlist`;
        const params = [{ key: 'catalogId', value: catalogId, name: 'buylater' }];
        const restApi = whislistUrl ? whislistUrl.split('/')[1] : 'itxrestservcart';
        const apiVersion = whislistUrl ? '4' : '2';
        const url = this.requestService.requestUrl(slug, languageId, params, true, apiVersion, restApi);

        return this.http.put<ApiPutWishlistResponse>(url, body, { withCredentials: true });
    }
}
